import React, { useState, useEffect } from "react";
import api from "../../../Services/api";
// import { useParams } from "react-router-dom";

const TrabalheConosco = (props: any) => {

  const [noticias, setNoticias] = useState<any>(); //{ Title: "", Corpo: "", CorpoTitle: "", Extra: "", ExtraTitle: "", video: "" });

  useEffect(() => {
    api.get("ObterLayoutPagina").then(response => {
       
       //filter response.data.results
        let tempResponse = response.data.results;
        let tempNoticias = tempResponse.filter(
          (item: any) => item.Identificador === "trabalhe-conosco"
        );
        setNoticias(tempNoticias[0]);
    })
      .catch(error => {
        throw new Error(error);

      });
  }, []);

  function renderObjectBody(data: any) {
    return { __html: data }
  }
  return (
    <>
      <div className="_the-content page-extrato pt-lg-6 pb-10">
        <div className='container'>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {noticias &&

                <div className="content">

                  {noticias.Corpo &&
                    <> <span dangerouslySetInnerHTML={renderObjectBody(noticias.Corpo)} />

                      <hr></hr> </>}

                  {noticias.Extra &&
                    <><span dangerouslySetInnerHTML={renderObjectBody(noticias.Extra)} /><hr className="my-7"></hr></>
                  }

                </div>
              }              
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default TrabalheConosco;